import React from 'react';
import { cn } from '@/utils/cn';
import { getImageUrl } from '@/utils/string';
import dynamic from 'next/dynamic';

const ReactPlayer = dynamic(() => import('react-player'), {
  ssr: false,
});

const imageBlurDataURL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';

function VideoPlayer({
  videoLink,
  onUserInteraction,
  smallDeviceRatio,
  largeDeviceRatio,
  height,
  className = '',
}) {
  return (
    <div className={cn('player-wrapper', className)}>
      <ReactPlayer
        light={
          <img
            src={imageBlurDataURL}
            alt="Video thumbnail"
            width={1440}
            height={720}
          />
        }
        url={getImageUrl(videoLink)}
        controls
        fallback
        onReady={() => onUserInteraction('ready')}
        onStart={() => onUserInteraction('play')}
        onPause={() => onUserInteraction('pause')}
        onEnded={() => onUserInteraction(false)}
        width="100%"
        height={height}
        style={{
          backgroundColor: '#444',
          maxWidth: '100%',
          width: '100%',
          aspectRatio: smallDeviceRatio,
          '@media (minWidth: 768px)': {
            aspectRatio: largeDeviceRatio,
          },
        }}
      />
    </div>
  );
}

export default VideoPlayer;
